import { Box, Theme, Typography } from "@outschool/backpack";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useSearchQuery } from "@outschool/ui-components-website";
import { Container, Link } from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import CardGrid, { CardGridListings } from "./CardGrid";
import { ActivityGridLoadingState } from "./CardLoadingStates";
import { ContentfulRelatedCategories } from "./RelatedCategories";

export default function RelatedCategoryGrid({
  category,
  limit,
  pageLocation,
  searchQueryResult,
  isTutoringCLP
}: {
  category: ContentfulRelatedCategories;
  limit: number;
  pageLocation: string;
  searchQueryResult: ReturnType<typeof useSearchQuery>;
  isTutoringCLP: boolean;
}) {
  const { exactListings, otherListings, loading } = searchQueryResult;
  const isMobile = useIsMobile();
  if (loading) {
    return <ActivityGridLoadingState cards={6} isTutoringCLP={isTutoringCLP} />;
  }

  let listings: CardGridListings = [...exactListings];
  if (exactListings.length < limit) {
    const difference = limit - exactListings.length;
    listings.push(...otherListings.slice(0, difference));
  }

  if (listings.length <= 1) {
    return <></>;
  }

  return (
    <Container fullBleed={isMobile}>
      <Box
        sx={(theme: Theme) => ({
          paddingBottom: "12px",

          [theme.breakpoints.down("md")]: {
            marginLeft: "1em",
            paddingBottom: 0
          }
        })}
      >
        <Typography emphasized variant="h4">
          {category.title}
        </Typography>
        <Typography
          variant="inherit"
          sx={{
            color: "grey.600",
            size: "22px"
          }}
        >
          {category.subTitle}
        </Typography>
      </Box>
      <CardGrid
        listings={listings}
        pageLocation={pageLocation}
        trackingLabel="related_category_grid_desktop"
        trackingProperties={{
          callToActionText: category.callToActionText,
          callToActionUrl: category.callToActionUrl
        }}
        variant="treatment"
        isTutoringCLP={isTutoringCLP}
      />
      {category.callToActionText && category.callToActionUrl && (
        <Box flex sx={{ alignItems: "center", marginTop: "20px" }}>
          <TrackedButton
            variant="outlined"
            component={Link}
            to={category.callToActionUrl}
            trackingName="related_category_grid_explore_more"
            trackingUniqueId={category.callToActionText}
            sx={{
              margin: "auto",
              whiteSpace: "unset"
            }}
          >
            {category.callToActionText}
          </TrackedButton>
        </Box>
      )}
    </Container>
  );
}
